import React from 'react';
import personalIcon from '../../../images/personal-icon.svg';
import * as Styled from './PersonalBlockStyles';
import {Col, Row} from 'react-bootstrap';
import Headline from '../Headline/Headline';

const PersonalBlock = React.memo(() => {
	return (
		<Styled.Wrapper fluid="xl" className="PersonalBlock">
			<Row className="align-items-center">
				<Col xs={12} md={5}>
					<Headline tag="h1">
						Cross-Platform<br/>
						Personal Search
					</Headline>
					<Styled.Paragraph>
						Trova is an AI-driven unified personal search platform that finds your scattered information across different workspaces. Our goal is to elevate your productivity in one search. No more head-scratching on where your content is. Trova is here to transform the way digital conversations are organized and accessed.
					</Styled.Paragraph>
					<Styled.StyledBtn href='/signin-beta' variant='primary'>
						Try Free
					</Styled.StyledBtn>
				</Col>
				<Col xs={12} md={7} className="d-none d-md-block">
					<Styled.StyledImg src={personalIcon} alt="About"/>
				</Col>
			</Row>
			{/*<Styled.Container className="Block">

			</Styled.Container>
			<Styled.Container className="Block">

			</Styled.Container>*/}
		</Styled.Wrapper>
	);
});

export default PersonalBlock;